import React, { useState } from 'react';
import { XIcon, HeartIcon, BrainIcon } from 'lucide-react';
const ExitPopup = ({
  isVisible,
  onClose
}) => {
  const affiliateUrl = 'https://track.decidely.se/click';
  const handleGetSolution = () => {
    window.location.href = affiliateUrl;
  };
  if (!isVisible) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 animate-fadeIn" data-id="element-25">
      <div className="bg-white rounded-xl max-w-md w-full p-6 relative shadow-2xl" data-id="element-26">
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-27">
          <XIcon className="h-5 w-5" data-id="element-28" />
        </button>
        <div className="text-center mb-5" data-id="element-29">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-50 rounded-full mb-4" data-id="element-30">
            <BrainIcon className="h-8 w-8 text-blue-600" data-id="element-31" />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-32">
            Vänta en sekund!
          </h2>
          <p className="text-gray-600 mb-1" data-id="element-33">
            Vi ser att du är orolig för ditt minne.
          </p>
          <p className="text-gray-600 mb-3" data-id="element-34">
            Vi har en lösning som kan hjälpa dig att återställa ditt minne redan
            inom 14 dagar.
          </p>
        </div>
        <div className="bg-blue-50 rounded-lg p-4 mb-5 border border-blue-100" data-id="element-35">
          <p className="text-sm text-blue-800" data-id="element-36">
            <span className="font-semibold" data-id="element-37">Visste du att:</span> 91% av våra
            kunder märker en förbättring av sitt minne redan inom 14 dagar?
            Brainy är det naturliga kosttillskottet som hjälper din hjärna att
            återställa förlorade neurala kopplingar.
          </p>
        </div>
        <div className="mb-5" data-id="element-38">
          <button onClick={handleGetSolution} className="w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg transition-all duration-300 transform hover:scale-105 pulse-button" data-id="element-39">
            Ja, jag vill förbättra mitt minne nu!
          </button>
        </div>
        <div className="text-center" data-id="element-40">
          <button onClick={onClose} className="text-sm text-gray-500 hover:text-gray-700 hover:underline" data-id="element-41">
            Nej tack, jag är inte intresserad av att förbättra mitt minne
          </button>
        </div>
      </div>
    </div>;
};
export default ExitPopup;